<template>
    <div class="row prospectus-search" >
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <label for="prospectus-name">{{conf.translations.nameOfCorporation}}</label><div v-show="!companiesReady" class="loading-spinner" />
            <select v-model="companyId" class="form-control" id="prospectus-name">
                <option v-for="company in companies" :key="company.companyId" :value="company.companyId">{{company.companyName}}</option>
            </select>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <label for="prospectus-type">{{conf.translations.typeOfProspectus}}</label>
            <select v-model="prospectusType" class="form-control" id="prospectus-type">
                <option v-for="(value, key) in conf.prospectusTypes" :key="key" :value="key">{{value}}</option>
            </select>
        </div>

        <div id="prospectus-datepicker-start" aria-label="alku" class="col-xs-6 col-sm-3 col-md-3 col-lg-2">
            <label>{{conf.translations.period}}</label><label for="prospectus-date-start" class="sr-only">Alku</label>
            <div class="input-group">
                <label for="prospectus-date-start" class="sr-only">{{conf.translations.startdate}}</label>
                <new-date-picker id="prospectus-date-start" @update-date="setPeriodStart" :placeholder="conf.translations.periodStart" v-once />
                <span @click="openstart" class="input-group-addon open-datepicker"><i class="calendar" aria-hidden="true"></i></span>
                <!--<datepicker format="dd.MM.yyyy" name="prospectus-date-start" typeable="true" :value="searchParams.PeriodBegin" @selected="setPeriodStart" :language="languages[conf.language]" :disabled-dates="DisabledDates.periodStart" :placeholder="conf.translations.periodStart" :monday-first="true" :bootstrap-styling="true">
                    <span slot="afterDateInput" class="input-group-addon" @click="clearPeriodStart"><i class="clear-btn" /></span>
                </datepicker>-->
            </div>
        </div>
        <div id="prospectus-datepicker-end" aria-label="loppu" class="col-xs-6 col-sm-3 col-md-3 col-lg-2">
            <label>&nbsp;</label>
            <div class="input-group">
                <label for="prospectus-date-end" class="sr-only">{{conf.translations.enddate}}</label>
                <new-date-picker id="prospectus-date-end" @update-date="setPeriodEnd" :placeholder="conf.translations.periodEnd" v-once />
                <span @click="openend" class="input-group-addon open-datepicker"><i class="calendar" aria-hidden="true"></i></span>
            </div>
            <!--<datepicker name="prospectus-date-end" typeable="true" :value="searchParams.PeriodEnd" @selected="setPeriodEnd" :language="languages[conf.language]" :disabled-dates="DisabledDates.periodEnd" :placeholder="conf.translations.periodEnd" :monday-first="true" :bootstrap-styling="true">
                <span slot="afterDateInput" class="input-group-addon" @click="clearPeriodEnd"><i class="clear-btn" /></span>
            </datepicker>-->
        </div>

        <div v-if="showListing" class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <label for="prospectus-listing">{{conf.translations.listing}}</label>
            <select v-model="listing" class="form-control" id="prospectus-listing">
                <option v-for="(value, key) in conf.listing" :key="key" :value="key">{{value}}</option>
            </select>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <label id="prospectus-search-button-id">&nbsp;</label>
            <div>
                <button id="prospectus-search-button" @click="Search" class="btn btn-default" aria-controls="prospectus-table">
                    {{conf.translations.search}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
    //import Datepicker from 'vuejs-datepicker';
    //import VueDatePicker from '@vuepic/vue-datepicker';
    //import '@vuepic/vue-datepicker/dist/main.css'
    import NewDatePicker from './DatePicker.vue';
    //import { en, fi, sv } from 'vuejs-datepicker/dist/locale';

    export default {
        components: {
            NewDatePicker
        },
        methods: {
            ...mapActions([
                'Search'
            ]),
            ...mapMutations([
                'setSearchParams',
            ]),
            setPeriodStart(value) {
                if (value.split('.').length === 3) {
                    this.setSearchParams({ PeriodBegin: new Date(value.split('.').reverse().join('/')) });
                } else if (value.split('/').length === 3) {
                    this.setSearchParams({ PeriodBegin: new Date(value) });
                } else {
                    this.setSearchParams({ PeriodBegin: null });
                }
            },
            setPeriodEnd(value) {
                if (value.split('.').length === 3) {
                    this.setSearchParams({ PeriodEnd: new Date(value.split('.').reverse().join('/')) });
                } else if (value.split('/').length === 3) {
                    this.setSearchParams({ PeriodEnd: new Date(value) });
                } else {
                    this.setSearchParams({ PeriodEnd: null });
                }
            },
            clearPeriodStart() {
                this.setSearchParams({ PeriodBegin: null });
            },
            clearPeriodEnd() {
                this.setSearchParams({ PeriodEnd: null });
            },
            openstart() {
                $('#prospectus-date-start').datepicker("show");
            },
            openend() {
                $('#prospectus-date-end').datepicker("show");
            }
        },
        computed: {
            ...mapState([
                'companies',
                'searchParams',
                'conf',
                'prospectusTypes',
                'prospectusTypesWithListing',
                'searching',
                'companiesReady'
            ]),
            ...mapGetters([
                'DisabledDates'
            ]),
            showListing() {
                return false; /*this.prospectusTypesWithListing.includes(this.searchParams.ProspectusType) && this.searchParams.ProspectusType !== null;*/
            },
            companyId: {
                get() {
                    
                    return this.searchParams.CompanyId !== undefined && this.searchParams.CompanyId !== null ? this.searchParams.CompanyId : 0;
                },
                set(value) {
                    this.setSearchParams({ CompanyId: value !==0 ? value : null });
                }
            },
            prospectusType: {
                get() {
                    return this.searchParams.ProspectusType !== undefined && this.searchParams.ProspectusType !== null ? this.searchParams.ProspectusType : 0;
                },
                set(value) {
                    let number = parseInt(value);
                    this.setSearchParams({ ProspectusType: number > 0 ? parseInt(value) : null });
                }
            },
            listing: {
                get() {
                    return this.searchParams.Listing !== undefined ? this.searchParams.Listing + 1 : 0;
                },
                set(value) {
                    let val = parseInt(value) - 1;
                    this.setSearchParams({ Listing: val >= 0 ? val : null });
                }
            }
        },
        data() {
            return {
                languages: {
                    en: "en",
                    fi: "fi",
                    sv: "sv"
                }
            }
        },
        mounted() {
            // Clear search history when refreshing the page
            this.clearPeriodStart(),
            this.clearPeriodEnd()
        }
    }
</script>